import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useQuery } from '@tanstack/react-query';
import { getRentedPlacesRequest } from '@/api';
import Button from '@/components/shared/Button';
import ChatDialog from '@/components/shared/ChatDialog';
import useGetRentedPlaces from '@/hooks/useGetRentedPlaces';
import React from 'react';
import './RentedPlacesTable.scss';
import { useNavigate } from 'react-router-dom';
import convertAddressToString from '@/utils/convertAddressToString';
import getAxiosErrors from '@/utils/getAxiosErrors';

const baseClass = 'RentedPlacesTable';

function RentedPlacesTable() {
  const navigate = useNavigate();
  const [chatId, setChatId] = React.useState<number | null | undefined>(null);
  const { data, isFetching, isLoading, error } = useGetRentedPlaces();

  if (isLoading || isFetching) {
    return <div>Loading...</div>;
  }

  if (error) {
    const { status, message } = getAxiosErrors(error);
    return (
      <div className="error">
        <div className="error-status">{status}</div>
        <div className="error-message">{message}</div>
      </div>
    );
  }

  return (
    <>
      <ChatDialog
        onClose={() => {
          setChatId(null);
        }}
        chatId={chatId}
      />
      <TableContainer component={Paper} elevation={0} className={baseClass}>
        <Table sx={{ minWidth: '300px' }} aria-label="simple table">
          <TableHead className={`${baseClass}--head`}>
            <TableRow className={`${baseClass}--head-tr`}>
              <TableCell className={`${baseClass}--head-th`}>
                <div className={`${baseClass}--head-th-content`}>
                  <div className={`${baseClass}--head-th-label`}>Address</div>
                  <div className={`${baseClass}--head-th-btns`}>
                    <i
                      className={`fa-solid fa-sort-up ${baseClass}--head-th-btns-icon active`}
                    ></i>
                    <i
                      className={`fa-solid fa-sort-down  ${baseClass}--head-th-btns-icon`}
                    ></i>
                  </div>
                </div>
              </TableCell>
              <TableCell align="left" className={`${baseClass}--head-th`}>
                <div className={`${baseClass}--head-th-label`}>
                  <div className={`${baseClass}--head-th-content`}>
                    <div className={`${baseClass}--head-th-label`}>Owner</div>
                    <div className={`${baseClass}--head-th-btns`}>
                      <i
                        className={`fa-solid fa-sort-up ${baseClass}--head-th-btns-icon `}
                      ></i>
                      <i
                        className={`fa-solid fa-sort-down  ${baseClass}--head-th-btns-icon`}
                      ></i>
                    </div>
                  </div>
                </div>
              </TableCell>
              <TableCell align="left" className={`${baseClass}--head-th`}>
                <div className={`${baseClass}--head-th-label`}>
                  <div className={`${baseClass}--head-th-content`}>
                    <div className={`${baseClass}--head-th-label`}>Rent</div>
                    <div className={`${baseClass}--head-th-btns`}>
                      <i
                        className={`fa-solid fa-sort-up ${baseClass}--head-th-btns-icon `}
                      ></i>
                      <i
                        className={`fa-solid fa-sort-down  ${baseClass}--head-th-btns-icon`}
                      ></i>
                    </div>
                  </div>
                </div>
              </TableCell>
              {/*<TableCell align="left" className={`${baseClass}--head-th`}>*/}
              {/*  <div className={`${baseClass}--head-th-label`}>*/}
              {/*    <div className={`${baseClass}--head-th-content`}>*/}
              {/*      <div className={`${baseClass}--head-th-label`}>44444</div>*/}
              {/*      <div className={`${baseClass}--head-th-btns`}>*/}
              {/*        <i*/}
              {/*          className={`fa-solid fa-sort-up ${baseClass}--head-th-btns-icon `}*/}
              {/*        ></i>*/}
              {/*        <i*/}
              {/*          className={`fa-solid fa-sort-down  ${baseClass}--head-th-btns-icon`}*/}
              {/*        ></i>*/}
              {/*      </div>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</TableCell>*/}
              {/*<TableCell align="left" className={`${baseClass}--head-th`}>*/}
              {/*  <div className={`${baseClass}--head-th-label`}>*/}
              {/*    <div className={`${baseClass}--head-th-content`}>*/}
              {/*      <div className={`${baseClass}--head-th-label`}>55555</div>*/}
              {/*      <div className={`${baseClass}--head-th-btns`}>*/}
              {/*        <i*/}
              {/*          className={`fa-solid fa-sort-up ${baseClass}--head-th-btns-icon`}*/}
              {/*        ></i>*/}
              {/*        <i*/}
              {/*          className={`fa-solid fa-sort-down  ${baseClass}--head-th-btns-icon`}*/}
              {/*        ></i>*/}
              {/*      </div>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</TableCell>*/}
              <TableCell
                align="center"
                className={`${baseClass}--head-th`}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...(data || [])].map((row) => (
              <TableRow
                className={`${baseClass}--row`}
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                onClick={() => {
                  console.log(row);
                }}
              >
                <TableCell scope="row" className={`${baseClass}--row-cell`}>
                  <div className={`${baseClass}--row-cell-address`}>
                    {convertAddressToString(row.address)}
                  </div>
                </TableCell>
                <TableCell align="left" className={`${baseClass}--row-cell`}>
                  <div className={`${baseClass}--row-cell-profile`}>
                    <div className={`${baseClass}--row-cell-profile-avatar`}>
                      {row.property?.owner?.avatar ? (
                        <img
                          src={row.property?.owner?.avatar || ''}
                          alt="avatar"
                          className={`${baseClass}--row-cell-profile-avatar-img`}
                        />
                      ) : (
                        <div
                          className={`${baseClass}--row-cell-profile-avatar-img`}
                        >
                          <i className="fa-solid fa-circle-user"></i>
                        </div>
                      )}
                    </div>
                    <div className={`${baseClass}--row-cell-profile-info`}>
                      <div
                        className={`${baseClass}--row-cell-profile-info-name`}
                      >
                        {row.property?.owner?.firstname}{' '}
                        {row.property?.owner?.lastname}
                      </div>
                      <div
                        className={`${baseClass}--row-cell-profile-info-email`}
                      >
                        {row.property?.owner?.email}
                      </div>
                    </div>
                    <Button
                      className={`${baseClass}--row-cell-profile-btn vacant`}
                      onClick={() => {
                        // navigate('/');
                        setChatId(row.property?.owner?.id);
                      }}
                    >
                      <i className="fa-regular fa-message"></i>
                    </Button>
                  </div>
                </TableCell>
                <TableCell align="left" className={`${baseClass}--row-cell`}>
                  {row.rentPrice ? (
                    <div className={`${baseClass}--row-cell-rent`}>
                      <div
                        className={`${baseClass}--row-cell-rent-price`}
                      >{`$ ${row.rentPrice}`}</div>
                      <div className={`${baseClass}--row-cell-rent-period`}>
                        per month
                      </div>
                    </div>
                  ) : (
                    <div className={`${baseClass}--row-cell-rent`}>-</div>
                  )}
                </TableCell>
                {/*<TableCell align="left" className={`${baseClass}--row-cell`}>*/}
                {/*  4*/}
                {/*</TableCell>*/}
                {/*<TableCell align="left" className={`${baseClass}--row-cell`}>*/}
                {/*  5*/}
                {/*</TableCell>*/}
                <TableCell align="right" className={`${baseClass}--row-cell`}>
                  <div className={`${baseClass}--unit`}>
                    <Button
                      className={`${baseClass}--unit-btn info`}
                      onClick={() => {
                        navigate(`/rented/${row.id}`);
                      }}
                    >
                      <i className="fa-solid fa-circle-info"></i>
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default RentedPlacesTable;
